import { Directive, Input, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[cms-host]'
})
export class DynamicCmsDirective {
  @Input() activeComponent:any
  
  constructor(public viewContainerRef: ViewContainerRef) { }

}
